import { useEffect, useRef } from "react";

const CustomCursor = () => {
  const cursorRef = useRef(null);

  const mouse = useRef({ x: 0, y: 0 });
  const pos = useRef({ x: 0, y: 0 });
  const lastMouse = useRef({ x: 0, y: 0 });

  useEffect(() => {
    let animationFrameId;
    let hasPointerPosition = false;

    const handleMouseMove = (e) => {
      if (!hasPointerPosition) {
        pos.current.x = e.clientX;
        pos.current.y = e.clientY;
        lastMouse.current.x = e.clientX;
        lastMouse.current.y = e.clientY;
        hasPointerPosition = true;

        if (cursorRef.current) {
          cursorRef.current.style.opacity = "1";
        }
      }

      mouse.current.x = e.clientX;
      mouse.current.y = e.clientY;
    };

    const handleMouseLeave = () => {
      if (cursorRef.current) {
        cursorRef.current.style.opacity = "0";
      }
    };

    const handleMouseEnter = () => {
      if (hasPointerPosition && cursorRef.current) {
        cursorRef.current.style.opacity = "1";
      }
    };

    window.addEventListener("mousemove", handleMouseMove);
    document.documentElement.addEventListener("mouseleave", handleMouseLeave);
    document.documentElement.addEventListener("mouseenter", handleMouseEnter);

    const speed = 0.08;
    const maxGap = 20;

    const animate = () => {
      // mouse movement speed
      const dx = mouse.current.x - lastMouse.current.x;
      const dy = mouse.current.y - lastMouse.current.y;
      const velocity = Math.sqrt(dx * dx + dy * dy);

      // dynamic gap (move = maxGap, stop = 0)
      const gap = Math.min(velocity * 1.5, maxGap);

      const targetX = mouse.current.x - gap;
      const targetY = mouse.current.y - gap;

      pos.current.x += (targetX - pos.current.x) * speed;
      pos.current.y += (targetY - pos.current.y) * speed;

      lastMouse.current.x = mouse.current.x;
      lastMouse.current.y = mouse.current.y;

      if (cursorRef.current && hasPointerPosition) {
        // Using pixel-aligned left/top avoids stale GPU-composited pixels that
        // can appear as red scratch marks while the cursor is moving quickly.
        cursorRef.current.style.left = `${Math.round(pos.current.x)}px`;
        cursorRef.current.style.top = `${Math.round(pos.current.y)}px`;
      }

      animationFrameId = requestAnimationFrame(animate);
    };

    animationFrameId = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationFrameId);
      window.removeEventListener("mousemove", handleMouseMove);
      document.documentElement.removeEventListener("mouseleave", handleMouseLeave);
      document.documentElement.removeEventListener("mouseenter", handleMouseEnter);
    };
  }, []);

  return (
    <div
      ref={cursorRef}
      style={{
        position: "fixed",
        top: "-7px",
        left: "-7px",
        width: "14px",
        height: "14px",
        backgroundColor: "#C72430",
        borderRadius: "50%",
        pointerEvents: "none",
        zIndex: 9999,
        opacity: 0,
        marginLeft: "-7px",
        marginTop: "-7px",
      }}
    />
  );
};

export default CustomCursor;
